import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import Hidden from "@insite/mobius/Hidden/Hidden";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomChevronLeft from "@tSurya/Icons/CustomChevronLeft";
import CustomChevronRight from "@tSurya/Icons/CustomChevronRight";
import { COLORS, COMMON, TYPOGRAPHY } from "@tSurya/theme/design";
import useEmblaCarousel from "embla-carousel-react";
import React, { createRef, FC, useEffect } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { css, ThemeProps, withTheme } from "styled-components";

interface Memberlist {
    fields: {
        img: string;
        title: string;
        maintitle: string;
        lowerText: string;
        path2: LinkFieldValue;
    };
}

const enum fields {
    divisions = "divisions",
    header = "header",
    description = "description",
    buttonLabel = "buttonLabel",
    buttonLink = "buttonLink",
    slideIndicator = "slideIndicator",
    buttonTextColor = "buttonTextColor",
    buttonBackgroundColor="buttonBackgroundColor",
    buttonLinkOpenInNewWindow = "buttonLinkOpenInNewWindow",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.divisions]: Memberlist[];
        [fields.header]: string;
        [fields.description]: string;
        [fields.buttonLabel]: string;
        [fields.buttonLink]: LinkFieldValue;
        [fields.buttonTextColor]: string;
        [fields.buttonBackgroundColor]:string;
        [fields.buttonLinkOpenInNewWindow]: string;
        [fields.slideIndicator]: boolean;
        lowerText: LinkFieldValue;
        path2: LinkFieldValue;
    };
    maxNumberOfColumns: number;
    maintitle: string;
    lowerText: LinkFieldValue;
    path2: LinkFieldValue;
}
type Props = OwnProps & ThemeProps<BaseTheme> & HasShellContext;

export interface Imgstyle {
    ContentImg?: InjectableCss;
    container?: InjectableCss;
    twrapper?: InjectableCss;
    parentDiv?: GridContainerProps;
    prevArrowWrapper?: InjectableCss;
    buttonPREV?: InjectableCss;
    ImageAndSpecialwrapper?: InjectableCss;
    main?: InjectableCss;
    nextArrowWrapper?: InjectableCss;
    buttonNEXT?: InjectableCss;
    button?: LinkPresentationProps;
    Maintitle?: InjectableCss;
    parentContainer?: InjectableCss;
    wrapper?: InjectableCss;
    subtittle?: InjectableCss;
    Box?: InjectableCss;
    h2wrapper?: InjectableCss;
    headerDiv?: InjectableCss;
    header?: InjectableCss;
    description?: InjectableCss;
    viewMoreBtn?: InjectableCss;
    dotButton?: InjectableCss;
    indicator?: InjectableCss;
}

export const imgstyle: Imgstyle = {
    Box: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
    ContentImg: {
        css: css`
            width: 100%;

            img {
                object-fit: cover;
                width: 100%;
                aspect-ratio: 1/1;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,

                    null,
                    null,
                ])}
        `,
    },

    buttonPREV: {
        css: css`
            padding: 0;
            span {
                background-color: ${getColor("primary.contrast")};
                svg {
                    color: #2c2420;
                    background-color: ${getColor("primary.contrast")};
                }
            }
        `,
    },
    buttonNEXT: {
        css: css`
            padding: 0;
            span {
                background-color: ${getColor("primary.contrast")};
                svg {
                    color: #2c2420;
                    background-color: ${getColor("primary.contrast")};
                }
            }
        `,
    },
    header: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.xxlarge};
            line-height: 36px;
            text-align: center;
            text-transform: uppercase;
            color: ${getColor("text.main")};
            margin-bottom: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 18px;
                        margin-bottom: 15px;
                        line-height: ${TYPOGRAPHY.lineHeight.larger};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        color: ${COLORS.featuredMobile};
                    `,
                    css`
                        margin-top: 18px;
                        margin-bottom: 15px;
                        line-height: ${TYPOGRAPHY.lineHeight.larger};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        color: ${COLORS.featuredMobile};
                    `,
                    css`
                        margin-top: 18px;
                        margin-bottom: 15px;
                        line-height: ${TYPOGRAPHY.lineHeight.larger};
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        color: ${COLORS.featuredMobile};
                    `,
                    null,
                    null,
                ])}
        `,
    },
    subtittle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: 23px;
            color: ${COLORS.text.main};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css``,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    prevArrowWrapper: {
        css: css`
            height: 10px;
            position: absolute;
            z-index: 1;
            top: 60%;
            left: -27px;
            > button[class^="ButtonWrapper"] {
                background-color: ${getColor("common.backgroundContrast")};
                border: 1px solid ${getColor("common.backgroundContrast")};
                outline: none;
                svg {
                    background-color: ${getColor("common.backgroundContrast")};
                }
            }
        `,
    },
    nextArrowWrapper: {
        css: css`
            position: absolute;
            z-index: 1;
            top: 60%;
            right: -27px;
            > button[class^="ButtonWrapper"] {
                background-color: ${getColor("common.backgroundContrast")};
                border: 1px solid ${getColor("common.backgroundContrast")};
                outline: none;
                svg {
                    background-color: ${getColor("common.backgroundContrast")};
                }
            }
        `,
    },
    twrapper: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.large};
            line-height: ${TYPOGRAPHY.lineHeight.medium};
            text-align: center;
            color: ${getColor("text.main")};
            text-transform: capitalize;
            margin-top: 15px;
        `,
    },
    parentContainer: {
        css: css`
            position: relative;
            padding: 0;
            width: 100%;
            max-width: 392px;
            flex: 0 0 auto;
            margin-right: 30px;
            margin-left: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100% !important;
                        margin-right: 20px;
                        margin-left: 10px;
                    `,
                    css`
                        max-width: 100% !important;
                        margin-right: 20px;
                        margin-left: 10px;
                    `,
                    css`
                        max-width: 100% !important;
                        margin-right: 20px;
                        margin-left: 10px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    parentDiv: {
        css: css`
            display: flex;
            /* grid-column-gap: 50px; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 0px;
                    `,
                    css`
                        gap: 0px;
                    `,

                    css`
                        /* gap: 25px; */
                    `,
                    null,
                    null,
                ])}
        `,
    },
    container: {
        css: css`
            overflow: hidden;
            width: 100%;
            /* width:calc(100% - 160px); */
            /* max-width: 1280px !important; */
        `,
    },
    wrapper: {
        css: css`
            position: relative;
            max-width: 100%;
            margin-left: auto;
            margin-right: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    css`
                        padding: 0;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    css`
                        padding: 0;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    ImageAndSpecialwrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            position: relative;
        `,
    },
    main: {
        css: css`
            position: relative;
            width: 100%;
            max-width: ${COMMON.width.content}px !important;
            margin: 0 auto;
        `,
    },
    h2wrapper: {
        css: css`
            border: 2px solid black;
        `,
    },
    headerDiv: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            justify-content: center;
            align-items: center;
        `,
    },
    description: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.larger};
            line-height: ${TYPOGRAPHY.lineHeight.lmedium};
            text-align: center;
            color: ${getColor("text.accent")};
            margin-bottom: 27px;
        `,
    },
  
    dotButton: {
        css: css`
            border-radius: 50%;
            background: #d9d9d9;
            margin: 5px;
            min-height: 10px !important;
            padding: 3px !important;
            &:hover,
            &:active {
                background: ${COLORS.primary.base};
            }
            &:focus {
                outline: none;
            }
        `,
    },
    indicator: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
        `,
    },
};

const styles = imgstyle;

export const SurInspirationSlides: FC<Props> = ({
    fields,
    maxNumberOfColumns = fields.divisions.length,
    theme,
    shellContext,
}) => {
    const { url } = useGetLink(fields.buttonLink);
    const afterCarousel = createRef<HTMLSpanElement>();

    const [emblaRef, embla] = useEmblaCarousel();

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [windowResizeTime, setWindowResizeTime] = useState(0);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);
    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    const getSlidesToScroll = useCallback(() => {
        // const maxNumberOfColumns = fields.divisions.length || 6;

        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 1;
        } else {
            localSlidesToScroll = 1;
        }
        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, [maxNumberOfColumns]);

    const [slidesToScroll, setSlidesToScroll] = useState(getSlidesToScroll());

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    const [draggable, setDraggable] = useState(getDraggable());

    useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);

        const newDraggable = getDraggable();
        setDraggable(newDraggable);
    }, [maxNumberOfColumns, windowResizeTime]);

    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        const onWindowResize = () => {
            setWindowResizeTime(Date.now());
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);
    const onWindowResize = () => {
        setWindowResizeTime(Date.now());
    };
    React.useEffect(() => {
        onWindowResize();
    }, []);

    React.useEffect(() => {
        if (!embla || !fields.divisions || fields.divisions.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            // draggable,
            loop: fields.divisions.length > slidesToScroll,
            // loop: fields.divisions.length > slidesToScroll,
        });
        setCanScroll();
    }, [embla, slidesToScroll, draggable, fields.divisions]);

    if (!fields.divisions || fields.divisions.length === 0) {
        return null;
    }

    const   viewMoreBtn = {
        css: css`
            padding: 10px 34px;
            background:${fields.buttonBackgroundColor};
            border-radius: 0px;
            border: 2px solid ${fields.buttonBackgroundColor};
            margin-bottom: 27px;
            :hover span[class^="TypographyStyle"] {
                color: ${fields.buttonTextColor};
            }
            span[class^="TypographyStyle"] {
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold};
                font-size: ${TYPOGRAPHY.size.base};
                line-height: 24px;
                color: ${fields.buttonTextColor};
            
            }
        `,
    }
    return (
        <>
            <StyledWrapper
                css={css`
                    opacity: 1;
                    position: relative;
                    margin: 0 auto;
                    margin-top: 40px;
                    padding-top: 30px;
                    padding-right: 60px;
                    padding-bottom: 43px;
                    padding-left: 60px;
                    background-color: ${getColor("common.backgroundContrast")};
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                padding: 0px;
                                padding-bottom: 20px;
                                margin-top: 0;
                            `,
                            css`
                                padding: 0px;
                                padding-bottom: 20px;
                                margin-top: 0;
                            `,
                            css`
                                padding: 0px;
                                padding-bottom: 20px;
                                margin-top: 0;
                            `,
                            null,
                            null,
                        ])};
                `}
            >
                <StyledWrapper {...styles.main}>
                    <StyledWrapper>
                        <StyledWrapper {...styles.headerDiv}>
                            <StyledWrapper {...styles.header}> {fields.header} </StyledWrapper>
                            <StyledWrapper {...styles.description}>{fields.description}</StyledWrapper>
                            {fields.buttonLabel && (
                                <Link {...viewMoreBtn} href={url} role="button">
                                    {fields.buttonLabel}
                                </Link>
                            )}
                        </StyledWrapper>
                        <StyledWrapper {...styles.Box}></StyledWrapper>
                        <Hidden below="lg">
                            <StyledWrapper>
                                {fields.divisions.length > 1 && (
                                    <StyledWrapper
                                        {...styles.prevArrowWrapper}
                                        style={{
                                            display: `${slidesToScroll >= fields.divisions.length ? "none" : "block"}`,
                                        }}
                                    >
                                        <Button
                                            {...styles.buttonPREV}
                                            onClick={() => {
                                                embla && embla.scrollPrev();
                                            }}
                                            disabled={!canScrollPrev}
                                        >
                                            <ButtonIcon src={CustomChevronLeft} />
                                        </Button>
                                    </StyledWrapper>
                                )}
                                <StyledWrapper
                                    {...styles.nextArrowWrapper}
                                    style={{
                                        display: `${slidesToScroll >= fields.divisions.length ? "none" : "block"}`,
                                    }}
                                >
                                    <Button
                                        {...styles.buttonNEXT}
                                        onClick={() => {
                                            embla && embla.scrollNext();
                                        }}
                                        disabled={!canScrollNext}
                                    >
                                        <ButtonIcon src={CustomChevronRight} />
                                    </Button>
                                </StyledWrapper>
                            </StyledWrapper>
                        </Hidden>
                    </StyledWrapper>

                    <StyledWrapper {...styles.wrapper}>
                        <StyledWrapper {...styles.container} ref={emblaRef}>
                            <StyledWrapper {...styles.parentDiv}>
                                {fields.divisions?.map((division, index) => {
                                    return (
                                        <>
                                            <StyledWrapper
                                                {...styles.parentContainer}
                                                style={{ width: `calc(100% / ${slidesToScroll})` }}
                                                key={index}
                                            >
                                                <StyledWrapper
                                                    css={css`
                                                        width: 100%;
                                                        height: 100%;
                                                        position: relative;
                                                        display: flex;
                                                        flex-direction: column;
                                                    `}
                                                >
                                                    <StyledWrapper {...styles.ImageAndSpecialwrapper}>
                                                        <LazyImage
                                                            {...styles.ContentImg}
                                                            src={division.fields.img}
                                                            altText={division.fields.title || "Surya Spaces Slide"}
                                                        />
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.twrapper}>
                                                        {division.fields.title}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </>
                                    );
                                })}
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
                <Hidden above="md" {...styles.indicator}>
                    {fields.slideIndicator && (
                        <StyledWrapper className="slide-indicator">
                            {fields.divisions.map((_, i) => {
                                const dotColorStyles =
                                    i === selectedIndex
                                        ? `
                                        background: white;
                                        &:hover { background: #000000; }
                                    `
                                        : "";
                                const dotButtonStyles = {
                                    css: css`
                                        ${styles.dotButton?.css || ""}
                                        ${dotColorStyles}
                                    `,
                                };

                                return (
                                    <Button
                                        className="slide-dot-button"
                                         
                                        key={i}
                                        {...dotButtonStyles}
                                        onClick={() => embla && embla.scrollTo(i)}
                                        role="button"
                                        aria-label="dot click"
                                    />
                                );
                            })}
                        </StyledWrapper>
                    )}
                </Hidden>
            </StyledWrapper>
        </>
    );
};

const settingsTab = {
    displayName: "Settings",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: withIsInShell(withTheme(SurInspirationSlides)),
    definition: {
        group: "Basic",
        displayName: "SurInspirationSlides",
        fieldDefinitions: [
            {
                name: fields.slideIndicator,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                tab: settingsTab,
            },
            {
                name: fields.header,
                displayName: "Header",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "text tip",
                placeholder: "text placeholder",
                isRequired: true,
                sortOrder: 0,
            },
            {
                name: fields.description,
                displayName: "Description",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "text tip",
                placeholder: "text placeholder",
                isRequired: true,
                sortOrder: 0,
            },
            {
                fieldType: "General",
                name: fields.buttonLabel,
                displayName: "Button Label",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.buttonBackgroundColor,
                displayName: "Button Background Color",
                editorTemplate: "ColorPickerField",
                defaultValue: ``,
                fieldType: "General",
            },
            {
                name: fields.buttonTextColor,
                displayName: "Button Text Color",
                editorTemplate: "ColorPickerField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                fieldType: "General",
                name: fields.buttonLink,
                displayName: "Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
            {
                name: fields.divisions,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { title } }) => title || "title",
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "img",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        displayName: "Image",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
